module.exports = __webpack_public_path__ + "static/media/Odkrywca.112bd663.svg";